import { RuntimeName } from '../types';
import { StorageDoesNotExists } from '../contextErrors';
import { ImmutableContextManager } from '../base';
import { GLOBAL_CONTEXT_MANAGER_KEY, CONTEXT_MANAGER_STORAGE_SCRIPT } from '../constants';

/**
 * The Browser context manager.
 * The storage is based on the "window" scope is expected to be provided by both NodeJS / Bundle Managers via `markup` method.
 */
class BrowserRuntimeContextManager extends ImmutableContextManager {
    runtimeName: RuntimeName = 'browser';

    constructor() {
        super();

        if (window[GLOBAL_CONTEXT_MANAGER_KEY]) {
            return this;
        }

        const stringifiesStorage = window?.document?.querySelector(
            `#${CONTEXT_MANAGER_STORAGE_SCRIPT}`
        )?.textContent;

        if (!stringifiesStorage) {
            return;
        }

        window[GLOBAL_CONTEXT_MANAGER_KEY] = Object.freeze(JSON.parse(stringifiesStorage));
    }

    /**
     * Returns the global context manager storage based on the "window" scope.
     */
    get storage() {
        const storage = window[GLOBAL_CONTEXT_MANAGER_KEY];

        if (!storage) {
            throw new StorageDoesNotExists(this.runtimeName);
        }

        return storage;
    }
}

export default BrowserRuntimeContextManager;
